module.exports = __webpack_public_path__ + "static/media/Serie-LPZ.90f74ff4.pdf";